import { FunctionComponent } from 'react'
import Modal from 'components/shared/Modal'
import { URL_FREE_TRIAL } from 'constants/links'

interface BrokenRefDialogProps {
  open: boolean
  onClose: () => void
}

const BrokenRefDialog: FunctionComponent<BrokenRefDialogProps> = ({ open, onClose }) => (
  <Modal
    open={open}
    onClose={onClose}
    title='Technical issue'
    size='small'
    actions={
      <button className='pointer bg-suez-canal br3 ph6 pv4 white f5 bn hover-o-90' onClick={onClose}>
        Close
      </button>
    }
  >
    This link is currently unavailable. Please{' '}
    <a href={URL_FREE_TRIAL} target='_blank' rel='noopener noreferrer'>contact us</a>{' '}
    if you need assistance.
  </Modal>
)

export default BrokenRefDialog
